import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styled, { keyframes } from 'styled-components';
import {
    Text,
    Flex,
    Caret
} from './';

const RowsContainer = styled.div`
    height: ${props => props.isOpen ? '300px' : '0px'};
    overflow-x: hidden;
    overflow-y: scroll;
    transition: height 0.5s;
`;

const DropdownRow = styled(Flex)`
    width: 100%;
    height: initial;
    justify-content: center;
    background: ${props => props.theme.rows};
    border-top: 1px solid ${props => props.theme.primaryBackgroundColor};
    border-bottom: 1px solid ${props => props.theme.primaryBackgroundColor};
`;

const DropdownRows = ({isOpen, displayNameKey, items, onSelect}) => {
    return (
        <RowsContainer isOpen={isOpen}>
            {
                items.map((item, i) => {
                    return (
                        <DropdownRow onClick={() => onSelect(item)} key={i}>
                            <Text primary>
                                {item[displayNameKey]}
                            </Text>
                        </DropdownRow>
                    );
                })
            }
        </ RowsContainer>
    );
};

const DropdownContainer = styled.div`
    background-color: ${props => props.theme.secondaryBackgroundColor};
    padding-bottom: ${props => props.isOpen ? '20px' : '0'};
`;

const SelectedBar = styled(Flex)`
    align-items: center;
    justify-content: center;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;

    @keyframes shake {
        15% {
            transform: translate3d(-15px, 0, 0);
        }
        30% {
            transform: translate3d(15px, 0, 0);
        }
        45% {
            transform: translate3d(-15px, 0, 0);
        }
        60% {
            transform: translate3d(10px, 0, 0);
        }
        75% {
            transform: translate3d(-5px, 0, 0);
        }
        90% {
            transform: translate3d(5px, 0, 0);
        }
        100% {
            transform: translate3d(0px, 0, 0);
        }
    }
`;

const AnimatedCaret = styled(Caret)`
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.5s;
`;

const SelectBarTitle = styled(Text)`
    margin: 10px 0 10px 0;
`

const DropDownHeader = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`
const AnimatedSelectedBar = styled(SelectedBar)`
    animation: ${props => props.valid ? 'none': 'shake 0.5s linear'};
`;

const HideFilter = keyframes`
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`;

const ShowFilter = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const FilterInput = styled.input`
    width: 210px;
    margin: 5px auto;
    display: ${props => props.isOpen ? 'block' : 'none'};
    opacity: ${props => props.isOpen ? 0 : 1};
    animation: ${props => props.isOpen ? ShowFilter : HideFilter} 0.5s both;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    font-size: 18px;
    height: 26px;
`

class DropdownSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredItems: false,
            filter: ''
        }

        this.onChangeFilter = this.onChangeFilter.bind(this);
    }

    onChangeFilter(event) {
        let value = event.target.value;
        let displayNameKey = this.props.displayNameKey;
        this.setState({filter: value});

        let filteredItems = this.props.items.filter((item) => {
            return item[displayNameKey].toUpperCase().includes(value.toUpperCase())
        });

        this.setState({filteredItems});
    };

    filterItems(value, displayNameKey, filter){
        return this.props.items.filter((item) => {
            return item[displayNameKey].toUpperCase().includes(filter.toUpperCase())
        });
    }

    render() {
        return (
            <DropdownContainer isOpen={this.props.isOpen}>
                <DropDownHeader>
                    <AnimatedSelectedBar valid={this.props.valid} onClick={this.props.onClick}>
                        <SelectBarTitle fontSize='22px' fontWeight='bold'>
                            {this.props.selectedItem || this.props.defaultText}
                        </SelectBarTitle>
                        <AnimatedCaret height='30px' width='30px' isOpen={this.props.isOpen}/>
                    </AnimatedSelectedBar>
                    <FilterInput isOpen={this.props.isOpen} onChange={this.onChangeFilter} value={this.state.filter} innerRef={this.input}/>
                </DropDownHeader>
                <DropdownRows isOpen={this.props.isOpen} displayNameKey={this.props.displayNameKey} items={this.state.filteredItems || this.props.items} onSelect={this.props.onSelect}/>
            </DropdownContainer>
        );
    };
};

DropdownSelect.propTypes = {
    onClick: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    displayNameKey: PropTypes.string.isRequired,
    valid: PropTypes.bool
};

DropdownSelect.defaultProps = {
    isOpen: false,
    valid: true,
    items: []
};

export default styled(DropdownSelect)`
    justify-content: space-between;
    align-items: center;
`;


// WEBPACK FOOTER //
// ./src/components/DropdownSelect.js